import * as React from "react";
import styled, { css } from "styled-components";
import { useWindowDimensions } from "@gravitywelluk/react-hooks";

import { Datetime } from "src/library/components/Datetime";
import { Text } from "src/library/components/Text";
import { breakpoint } from "src/library/utils/styled-media-queries";
import { IOrderAuditLog } from "src/core/orders/api/orders.api";

type AuditLogDateHeaderProps = Pick<IOrderAuditLog, "createdAt" | "updatedByUser">;

export const AuditLogDateGroup: React.ReactFCWithChildren<AuditLogDateHeaderProps> = ({
  createdAt, updatedByUser, children
}) => {
  const { width } = useWindowDimensions();

  return (
    <>
      <AuditLogDateHeaderWrapper>
        <Text>
          <Datetime
            date={createdAt}
            template={(width && width > 700) ? "long_date_time" : "datetime"}
          />

          <div className="updated-by">
            {" by "}

            <Text weight="bold">
              {`${updatedByUser.firstName} ${updatedByUser.lastName} ${(width || 0) > 700 && updatedByUser.id !== 1 ? `(${updatedByUser.email})` : ""}`}
            </Text>
          </div>
        </Text>
      </AuditLogDateHeaderWrapper>

      <AuditLogItemsWrapper>
        {children}
      </AuditLogItemsWrapper>
    </>
  );
};

const AuditLogItemsWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    padding-left: calc(10px + ${theme.spacing.padding.lg});

    &:before {
      content: "";
      display: block;
      width: 2px;
      height: 100%;
      background: ${theme.colors.lightGrey};
      border-radius: ${theme.borderRadius};
      position: absolute;
      left: 3px;
      top: calc(${theme.spacing.margins.md} / 2);
    }

    &:last-child:before {
      display: none;
    }

    .updated-by {
      display: block;
    }

    ${breakpoint("md", theme)} {
      .updated-by {
        display: inline;
      }
    }
  `}
`;

const AuditLogDateHeaderWrapper = styled.div`
${({ theme }) => css`
    position: relative;
    padding-left: calc(10px + ${theme.spacing.padding.lg});

    &:before {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      background: ${theme.colors.midGrey};
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  `}
`;
